// app/javascript/controllers/copy_to_clipboard_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button"];

  async copy() {
    const el = this.contentTarget;
    const html = el.innerHTML;
    const text = el.innerText;

    const btn = this.hasButtonTarget ? this.buttonTarget : null;
    const original = btn ? btn.innerHTML : null;

    try {
      // Prefer rich clipboard when available
      if (navigator.clipboard && window.ClipboardItem) {
        const item = new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([text], { type: "text/plain" }),
        });

        await navigator.clipboard.write([item]);
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        // Very old fallback
        this.legacyCopyText(text);
      }

      if (btn) this.flashButton(btn, original, "Copied!");
    } catch (e) {
      // If HTML copy fails due to permissions, at least try plain text
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          if (btn) this.flashButton(btn, original, "Copied!");
          return;
        }
      } catch (_) {}

      if (btn) this.flashButton(btn, original, "Copy failed");
      // optional: console for debugging
      // console.warn("[copy-to-clipboard] copy failed", e);
    }
  }

  legacyCopyText(text) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }

  flashButton(btn, originalHtml, label) {
    btn.disabled = true;
    btn.innerHTML = `<i class="bi bi-check2"></i><span class="ms-1">${label}</span>`;
    window.setTimeout(() => {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    }, 1200);
  }
}
